import PartnerEndpoints from "../../pages/Customer/endpoints";
import ExternalTemplates from "../../pages/Customer/externalTemplates";
import { createProtectedRoutes } from "../../utils/createdProtectedRoutes";

export const ROUTE = "Partner";

const routesConfig = [
  { path: `${ROUTE}/EndPoints`, component: PartnerEndpoints, roles: [1, 2, 3] },
  {
    path: `${ROUTE}/ExternalTemnplates`,
    component: ExternalTemplates,
    roles: [1, 2, 3],
  },
];

const partnerRoutes = createProtectedRoutes(routesConfig);
export default partnerRoutes;
